export const AppConstants = {

  TELEFONO_ASISTENCIA: '56 3096 7932',
  TELEFONO_800: '56 3096 7932',
  WHATSAPP: '+52 55 746 20359',
  WHATSAPP_LINK: 'https://api.whatsapp.com/send?phone=525574620359',

}
